
            //------------------------------------------------------------------------------
            // <auto-generated>
            //     This code was generated from a template.
            //
            //     Manual changes to this file may cause unexpected behavior in your application.
            //     Manual changes to this file will be overwritten if the code is regenerated.
            // </auto-generated>
            //------------------------------------------------------------------------------
        
	export enum Localization {
		 AcceptTheCrop = 'acceptTheCrop',
		 Account = 'account',
		 Actions = 'actions',
		 AddMessage = 'addMessage',
		 AddMultimedium = 'addMultimedium',
		 Address = 'address',
		 All = 'all',
		 AllBuildings = 'allBuildings',
		 Announcements = 'announcements',
		 Application = 'application',
		 ApplicationName = 'applicationName',
		 AreYouSureYouWantToDeleteDocument = 'areYouSureYouWantToDeleteDocument',
		 AreYouSureYouWantToDeleteThisPhoto = 'areYouSureYouWantToDeleteThisPhoto',
		 AssignedStructure = 'assignedStructure',
		 Back = 'back',
		 Building = 'building',
		 BuildingDocumentsVisibleForResident = 'buildingDocumentsVisibleForResident',
		 BuildingManager = 'buildingManager',
		 ButtonIsntWorkingMessage = 'buttonIsntWorkingMessage',
		 By = 'by',
		 Cancel = 'cancel',
		 ChangeDocumentVisibility = 'changeDocumentVisibility',
		 ChappsAccount = 'chappsAccount',
		 Close = 'close',
		 Company = 'company',
		 Completed = 'completed',
		 ConfirmAccount = 'confirmAccount',
		 Contact = 'contact',
		 ContactDocuments = 'contactDocuments',
		 CreateAnnouncementErrorMessage = 'createAnnouncementErrorMessage',
		 CreateNotification = 'createNotification',
		 CreateNotificationErrorMessage = 'createNotificationErrorMessage',
		 CreateNotificationSuccessMessage = 'createNotificationSuccessMessage',
		 CropAllImagesAutomatically = 'cropAllImagesAutomatically',
		 CropImagesBeforeUpload = 'cropImagesBeforeUpload',
		 Dashboard = 'dashboard',
		 DateOfBirth = 'dateOfBirth',
		 Day = 'day',
		 Dear = 'dear',
		 Delete = 'delete',
		 DeletePhotoErrorMessage = 'deletePhotoErrorMessage',
		 Description = 'description',
		 Details = 'details',
		 Discard = 'discard',
		 DisplayFrom = 'displayFrom',
		 DisplayTo = 'displayTo',
		 Documents = 'documents',
		 Download = 'download',
		 Edit = 'edit',
		 EditDetails = 'editDetails',
		 EditInfo = 'editInfo',
		 Email = 'email',
		 EmptyChatMessage = 'emptyChatMessage',
		 EmptyDataMessage = 'emptyDataMessage',
		 ErrorHeader = 'errorHeader',
		 ErrorMessage = 'errorMessage',
		 ErrorSubheader = 'errorSubheader',
		 Filter = 'filter',
		 Filters = 'filters',
		 For = 'for',
		 ForFurtherInformationPleaseVisitYourResidenzWebsite = 'forFurtherInformationPleaseVisitYourResidenzWebsite',
		 From = 'from',
		 FullName = 'fullName',
		 Functions = 'functions',
		 GetBuildingForContactErrorMessage = 'getBuildingForContactErrorMessage',
		 GoToContact = 'goToContact',
		 GoToContactInApplication = 'goToContactInApplication',
		 GoToIssue = 'goToIssue',
		 HerebyYouWillFindAnAnnouncementOfBusinessToAllTheResidentsOfBuilding = 'herebyYouWillFindAnAnnouncementOfBusinessToAllTheResidentsOfBuilding',
		 Hour = 'hour',
		 Id = 'id',
		 IdCardNumber = 'idCardNumber',
		 Info = 'info',
		 InvalidEmail = 'invalidEmail',
		 InviteResident = 'inviteResident',
		 InviteResidentErrorMessage = 'inviteResidentErrorMessage',
		 InviteResidentSuccessMessage = 'inviteResidentSuccessMessage',
		 IssueNotificationHandled = 'issueNotificationHandled',
		 IssueNotificationStatusErrorMessage = 'issueNotificationStatusErrorMessage',
		 IssueNotificationStatus_Handled = 'issueNotificationStatus_Handled',
		 IssueNotificationStatus_Open = 'issueNotificationStatus_Open',
		 IssueNotificationStatus_Processing = 'issueNotificationStatus_Processing',
		 IssueNotificationStatus_WithoutConsequence = 'issueNotificationStatus_WithoutConsequence',
		 KindRegards = 'kindRegards',
		 Label = 'label',
		 Language = 'language',
		 Lang_de = 'lang_de',
		 Lang_en = 'lang_en',
		 Lang_es = 'lang_es',
		 Lang_fr = 'lang_fr',
		 Lang_it = 'lang_it',
		 Lang_nl = 'lang_nl',
		 Lang_nl_BE = 'lang_nl_BE',
		 Latest = 'latest',
		 LatestMessages = 'latestMessages',
		 LatestNotifications = 'latestNotifications',
		 LinkedDocuments = 'linkedDocuments',
		 Location = 'location',
		 Login = 'login',
		 Logout = 'logout',
		 MailFooter = 'mailFooter',
		 ManagerSentYouMessageRegardingOneOfYourNotifications = 'managerSentYouMessageRegardingOneOfYourNotifications',
		 MarkAsRead = 'markAsRead',
		 MarkAsReadErrorMessage = 'markAsReadErrorMessage',
		 Media = 'media',
		 Message = 'message',
		 Messages = 'messages',
		 Minute = 'minute',
		 Month = 'month',
		 New = 'new',
		 NewAnnouncement = 'newAnnouncement',
		 NewNotification = 'newNotification',
		 No = 'no',
		 NotificationPhotosSyncInfo = 'notificationPhotosSyncInfo',
		 Notifications = 'notifications',
		 NotificationsPerBuilding = 'notificationsPerBuilding',
		 NotificationStatus_Handled = 'notificationStatus_Handled',
		 NotificationStatus_Open = 'notificationStatus_Open',
		 NotificationStatus_Processing = 'notificationStatus_Processing',
		 NotificationStatus_WithoutConsequence = 'notificationStatus_WithoutConsequence',
		 ObservedOn = 'observedOn',
		 Observer = 'observer',
		 Open = 'open',
		 OpenNotifications = 'openNotifications',
		 OpenNotificationsTab = 'openNotificationsTab',
		 Or = 'or',
		 Phone = 'phone',
		 PleaseAddAnEmailAddressToThisContactFirst = 'pleaseAddAnEmailAddressToThisContactFirst',
		 Preview = 'preview',
		 PromoteToIssue = 'promoteToIssue',
		 PromoteToIssueErrorMessage = 'promoteToIssueErrorMessage',
		 QuickSearch = 'quickSearch',
		 Read = 'read',
		 ReadBy = 'readBy',
		 RentalManager = 'rentalManager',
		 Reply = 'reply',
		 RequestErrorMessage = 'requestErrorMessage',
		 Required = 'required',
		 ResendInvite = 'resendInvite',
		 ResidentLoginStatus_Invited = 'residentLoginStatus_Invited',
		 ResidentLoginStatus_NotInvited = 'residentLoginStatus_NotInvited',
		 ResidentLoginStatus_Registered = 'residentLoginStatus_Registered',
		 Residents = 'residents',
		 RoomsManager = 'roomsManager',
		 Search = 'search',
		 SeeMore = 'seeMore',
		 SelectedImage = 'selectedImage',
		 Send = 'send',
		 SendNotificationMessageErrorMessage = 'sendNotificationMessageErrorMessage',
		 SentMessage = 'sentMessage',
		 SetCultureErrorMessage = 'setCultureErrorMessage',
		 ShowExpiredAnnouncements = 'showExpiredAnnouncements',
		 SignOut = 'signOut',
		 SoLetsGetStartedSimplyConfirmYourAccountByClickingTheButtonBelow = 'soLetsGetStartedSimplyConfirmYourAccountByClickingTheButtonBelow',
		 Source = 'source',
		 SourcePlaceholder = 'sourcePlaceholder',
		 Status = 'status',
		 Submit = 'submit',
		 Synchronize = 'synchronize',
		 TheButtonWillDirectYouToAConfirmationPageWhereYouCanChooseAPassword = 'theButtonWillDirectYouToAConfirmationPageWhereYouCanChooseAPassword',
		 TheChappsResidenzTeam = 'theChappsResidenzTeam',
		 TheMessageIs = 'theMessageIs',
		 ThisAnnouncementDoesNotHaveAnyDocumentsYet = 'thisAnnouncementDoesNotHaveAnyDocumentsYet',
		 ThisAnnouncementHasNotBeenReadByAnyoneYet = 'thisAnnouncementHasNotBeenReadByAnyoneYet',
		 ThisResidentDoesNotHaveAnyDocumentsYet = 'thisResidentDoesNotHaveAnyDocumentsYet',
		 ThisResidentDoesNotHaveAnyFunctionsYet = 'thisResidentDoesNotHaveAnyFunctionsYet',
		 ThisResidentDoesNotHaveNotifications = 'thisResidentDoesNotHaveNotifications',
		 Title = 'title',
		 TitleLengthRestriction = 'titleLengthRestriction',
		 To = 'to',
		 Type = 'type',
		 Unread = 'unread',
		 UnreadMessages = 'unreadMessages',
		 UnreadMessagesOnly = 'unreadMessagesOnly',
		 UnsupportedDocumentsExtensionsMessage = 'unsupportedDocumentsExtensionsMessage',
		 UnsupportedPhotoExtensionMessage = 'unsupportedPhotoExtensionMessage',
		 UpdateAnnouncementErrorMessage = 'updateAnnouncementErrorMessage',
		 ResendAnnouncementErrorMessage = 'resendAnnouncementErrorMessage',
		 UpdateNotificationErrorMessage = 'updateNotificationErrorMessage',
		 UploadPhotoErrorMessage = 'uploadPhotoErrorMessage',
		 VisibleForResident = 'visibleForResident',
		 Year = 'year',
		 Yes = 'yes',
		 YourPropertyManagerHasPreparedYourAccessToTheChappsResidenzWebsite = 'yourPropertyManagerHasPreparedYourAccessToTheChappsResidenzWebsite',
		 RecordVideoHeader = 'recordVideoHeader',
		 Record = 'record',
		 StopRecording = 'stopRecording',
		 VideoClipPreviewHeader = 'videoClipPreviewHeader',
		 VideoProcessingInfo = 'videoProcessingInfo',
		 UploadFile = 'uploadFile',
		 Uploading = 'uploading',
		 UseCamera = 'useCamera',
		 TakeAPhoto = 'takeAPhoto',
		 ConfirmDeleteVideo = 'confirmDeleteVideo',
		 FileOverSizeLimit = 'fileOverSizeLimit',
		 MaximumUploadFileSize = 'maximumUploadFileSize',
		 InviteResidents = 'inviteResidents',
		 InviteResidentsErrorMessage = 'inviteResidentsErrorMessage',
		 InviteResidentsSuccessMessage = 'inviteResidentsSuccessMessage',
		 InviteResidentsTooltip = 'inviteResidentsTooltip',
		 Lang_hu = 'lang_hu',
		 AnnouncementsDescription = 'announcementsDescription',
		 DocumentsDescription = 'documentsDescription',
		 IssueStatusDescription = 'issueStatusDescription',
		 BuildingDescription = 'buildingDescription',
		 DwellingDescription = 'dwellingDescription',
		 ExternalDescription = 'externalDescription',
		 Contacts = 'contacts',
		 Helpdesk = 'helpdesk',
		 ResendAllAnnouncements = 'resendAllAnnouncements',
		 ResendUnreadAnnouncements = 'resendUnreadAnnouncements',
		 SortBy = 'sortBy',
		 NewestFirst = 'newestFirst',
		 OldestFirst = 'oldestFirst',
		 ProblemStatus = 'problemStatus',
		 ResendSuccesful = 'resendSuccesful',
		 InviteResidentsPartialFailMessage = 'inviteResidentsPartialFailMessage',
		 PlaceAndDescription = 'placeAndDescription',
		 Reported = 'reported',
		 PlaceAndMessage = 'placeAndMessage',
		 ProblemsPresent = 'problemsPresent',
		 DateOfLastProblem = 'dateOfLastProblem',
		 BusinessStyle = 'businessStyle',
		 Logins = 'logins',
		 Settings = 'settings',
		 Active = 'active',
		 Inactive = 'inactive',
		 LicenseNotAgreed = 'licenseNotAgreed',
		 NotConfirmed = 'notConfirmed',
		 Activate = 'activate',
		 ResendInvitationMail = 'resendInvitationMail',
		 TitleAndUploadDate = 'titleAndUploadDate',
		 UploadedBy = 'uploadedBy',
		 Help = 'help',
		 PrimaryColor = 'primaryColor',
		 Save = 'save',
		 Reset = 'reset',
		 PrimaryTextColor = 'primaryTextColor',
		 SecondaryColor = 'secondaryColor',
		 SecondaryTextColor = 'secondaryTextColor',
		 TextColor = 'textColor',
		 TitleTextColor = 'titleTextColor',
		 CustomiseCompanyLogo = 'customiseCompanyLogo',
		 CustomiseApplicationTitle = 'customiseApplicationTitle',
		 CustomiseApplicationTitleTip = 'customiseApplicationTitleTip',
		 BaseColor1Title = 'baseColor1Title',
		 BaseColor1Tip = 'baseColor1Tip',
		 BaseColor1Description = 'baseColor1Description',
		 BaseColor2Title = 'baseColor2Title',
		 BaseColor2Tip = 'baseColor2Tip',
		 BaseColor2Description = 'baseColor2Description',
		 Accent1Title = 'accent1Title',
		 Accent1Tip = 'accent1Tip',
		 Accent1Description = 'accent1Description',
		 Accent2Title = 'accent2Title',
		 Accent2Description = 'accent2Description',
		 Progress1Title = 'progress1Title',
		 Progress1Tip = 'progress1Tip',
		 Progress1Description = 'progress1Description',
		 Progress2Tip = 'progress2Tip',
		 Progress2Description = 'progress2Description',
		 CardColorTitle = 'cardColorTitle',
		 CardColorTip = 'cardColorTip',
		 CardColorDescription = 'cardColorDescription',
		 ChevronColorTitle = 'chevronColorTitle',
		 ChevronColorTip = 'chevronColorTip',
		 ChevronColorDescription = 'chevronColorDescription',
		 NotificationColorTitle = 'notificationColorTitle',
		 NotificationColorTip = 'notificationColorTip',
		 NotificationColorDescription = 'notificationColorDescription',
		 MenuTextTitle = 'menuTextTitle',
		 MenuTextTip = 'menuTextTip',
		 MenuTextDescription = 'menuTextDescription',
		 CustomiseSignInBackground = 'customiseSignInBackground',
		 CustomiseSignInBackgroundTip = 'customiseSignInBackgroundTip',
		 Accent2Tip = 'accent2Tip',
		 January = 'january',
		 Progress2Title = 'progress2Title',
		 February = 'february',
		 March = 'march',
		 April = 'april',
		 May = 'may',
		 June = 'june',
		 July = 'july',
		 August = 'august',
		 September = 'september',
		 October = 'october',
		 November = 'november',
		 December = 'december',
		 SpfSettingsTitle = 'spfSettingsTitle',
		 SpfSettingsRecordsTitle = 'spfSettingsRecordsTitle',
		 SpfSettingsRecordsExplanation = 'spfSettingsRecordsExplanation',
		 SpfHostname = 'spfHostname',
		 SpfRecord = 'spfRecord',
		 SpfSettingsNoRecords = 'spfSettingsNoRecords',
		 SpfSettingsInstructionsTitle = 'spfSettingsInstructionsTitle',
		 SpfSettingsInstructions = 'spfSettingsInstructions',
		 SpfSettingsInstructionsRemarksTitle = 'spfSettingsInstructionsRemarksTitle',
		 SpfSettingsInstructionsRemarkOnFieldNames = 'spfSettingsInstructionsRemarkOnFieldNames',
		 SpfSettingsInstructionsRemarkOnPropagation = 'spfSettingsInstructionsRemarkOnPropagation',
		 SpfSettingsAddModalTitle = 'spfSettingsAddModalTitle',
		 SpfSettingsGenerateRecordCta = 'spfSettingsGenerateRecordCta',
		 SpfSettingsEditModalTitle = 'spfSettingsEditModalTitle',
		 SpfSettingsDeleteModalMessage = 'spfSettingsDeleteModalMessage',
		 SpfSettingsDeleteConfirmation = 'spfSettingsDeleteConfirmation',
		 SpfSettingsUpdateConfirmation = 'spfSettingsUpdateConfirmation',
		 CopiedToClipboard = 'copiedToClipboard',
		 AddResidentTooltip = 'addResidentTooltip',
		 AddResidentDialogTitle = 'addResidentDialogTitle',
		 AddResidentDialogMessage = 'addResidentDialogMessage',
		 AddResidentDialogConfirmAction = 'addResidentDialogConfirmAction',
		 EmailSetttingsFromAddressLabel = 'emailSetttingsFromAddressLabel',
		 EmailSettingsFromAddressDescription = 'emailSettingsFromAddressDescription',
		 EmailSettingsTitle = 'emailSettingsTitle',
		 EmailSettingsFromAddressSavedNotification = 'emailSettingsFromAddressSavedNotification',
		 EmailConfigurationTitle = 'emailConfigurationTitle',
		 EmailSettingFromAddressLabel = 'emailSettingFromAddressLabel',
		 MediaLogImageAddedPlural = 'mediaLogImageAddedPlural',
		 MediaLogImageAddedSingular = 'mediaLogImageAddedSingular',
		 EmptyStateMediaMessage = 'emptyStateMediaMessage',
		 Image = 'image',
	}


